import React from 'react';
import PropTypes from "prop-types";


AppNavigationLink.propTypes = {
    name: PropTypes.string,
    href: PropTypes.string,
    onClick: PropTypes.func,
    img: PropTypes.string,
    isMenuOpen: PropTypes.bool,
};

export default function AppNavigationLink(props) {

    const {href, img, name, pathName, hideOnMobile, onClick, isMenuOpen, currentPath} = props;

    const getActive = () => {
        return pathName === currentPath ? " active" : "";
    };

    const hideOnMobileDevice = () => {
        return hideOnMobile ? " mobile-no" : "";
    };

    return (
        <div className={"nav-item" + hideOnMobileDevice() + getActive()}>
            <a className="nav-icon" href={href ? href : null} onClick={onClick && onClick}>
                <img src={img} alt=""/>
            </a>
            <a href={href ? href : null} onClick={onClick && onClick}>
                <div className={"nav-text" + (isMenuOpen ? "" : " close-icon")}>{name}</div>
            </a>
        </div>
    )
}
